<template>
  <div class="content text-left">
    <b-container>
      <b-row>
        <b-col md="12" sm="12">
          <div class="title">
              <p>{{ title }}</p>
          </div>
          <!-- <div class="applynowbtn">
              <button type="button" class="applying-btn btn btn-danger" @click="applyLink()">Apply Now</button>
          </div> -->
          <div class="info">
              <p>{{ info }}</p>
          </div>
          <div class="tickedText">
              <ul id="additionalInfoList">
                <li
                  id="list-content"
                  v-for="additional in additionalInfo"
                  :key="additional"
                >
                  <b-icon class="mr-1" icon="check-circle"></b-icon> {{ additional }}
                </li>
              </ul>
          </div>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>
<script>
export default {
  name: "Header-Content",
  props: ["title", "info", "additionalInfo"],
  methods:{
    applyLink(){
     // window.location.href = ("https://www.ftcash.com/app/loan/index", '_blank');
      window.open("https://www.ftcash.com/app/loan/index", '_blank');
    }
  }
};
</script>
<style scoped>
#additionalInfoList {
  font-size: 17px;
  list-style-type: none;
  list-style-position: inside;
  padding: 0;
  margin-bottom:0;
}
#list-content {
  margin-top: 1rem;
}

.content {
  color: var(--mainWhiteColor);
}
.info {
  font-size: 17px;
  width: 60%;
  margin-top: 2rem;
}

.btn-danger {
  background-color: var(--mainRedColor);
  box-shadow: 0 0 2px 0 rgba(0, 0, 0, 0.4);
}

.btn-danger:hover {
    color: #fff;
    background-color: #c82333;
    border-color: #bd2130;
    box-shadow: 0px 0px 2px rgba(208, 208, 208, 0.4);
}

.title {
    font-size: 2.5rem;
    font-weight: 600;
    width:55%;
}
.applynowbtn{
  margin-top: 2rem;
}

/* Media Queries */
/* Tablet View */
@media (min-width: 768px) and (max-width: 1024px) and (orientation: portrait) {
  .title {
    font-size: 2.25rem;
    font-weight: 500;
    width: 79%;
   /*text-shadow: 1px 1px black;*/
  }
  .info {
    font-size: 1.3rem;
    width: 100%;
    /*text-shadow: 1px 1px black;*/
  }
  .applying-btn{
    font-size: 1.25rem;
    margin: 2rem 0;
  }
  #additionalInfoList {
    font-size: 1.125rem;
  }
  #list-content {
    padding-top: 0.9rem;
    /*text-shadow: 1px 1px black;*/
  }
}
@media (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {
  .title {
    font-size: 2rem;
    font-weight: 500;
   /*text-shadow: 1px 1px black;*/
  }
  .info {
    font-size: 1.25rem;
   /*text-shadow: 1px 1px black;*/
  }
  .applying-btn{
    font-size: 0.80rem;
    margin: 1rem 0;
  }
  #additionalInfoList {
    font-size: 1rem;
  }
  #list-content {
    padding-top: 0.75rem;
    /*text-shadow: 1px 1px black;*/
  }
}
/* Mobile View */
@media (min-width: 480px) and (max-width: 767px) and (orientation: portrait){
  .title {
      font-size: 1.5rem;
      font-weight: 500;
      width:100%;
     /*text-shadow: 1px 1px black;*/
  }
  .info {
    font-size: 1.125rem;
    width:100%;
   /*text-shadow: 1px 1px black;*/
  }
  .applying-btn{
        font-size: 0.80rem;
  }
  #additionalInfoList {
    font-size: 0.9rem;
  }
  #list-content {
    padding-top: 0.5rem;
    margin-top:0;
    /*text-shadow: 1px 1px black;*/
  }
}

@media (min-width: 480px) and (max-width: 767px) and (orientation: landscape) {
  .title {
      font-size: 1.5rem;
      font-weight: 500;
      width:100%;
      /*text-shadow: 1px 1px black;*/
  }
  .info {
    font-size: 0.9rem;
    width:100%;
    /*text-shadow: 1px 1px black;*/
        margin: 1.75rem 0 1rem 0;
  }
  .applying-btn{
        font-size: 0.80rem;
  }
  #additionalInfoList {
    font-size: 0.8rem;
  }
  #list-content {
    padding-top: 0.5rem;
    margin-top:0;
    /*text-shadow: 1px 1px black;*/
  }
}


/* Small Mobile */
@media (max-width: 480px) and (orientation: portrait){
  .title {
    font-size: 1.5rem;
    font-weight: 500;
    width: 100%;
    /*text-shadow: 1px 1px black;*/
  }
  .info {
    font-size: 1rem;
    width: 100%;
    /*text-shadow: 1px 1px black;*/
  }
  .applying-btn{
    font-size: 0.80rem;
  }
  #additionalInfoList {
    font-size: 0.9rem;
  }
  #list-content {
    padding-top: 0.5rem;
    margin-top:0;
    /*padding-top: 0.5rem;*/
    /*text-shadow: 1px 1px black; */
  }
}

@media (max-width: 480px) and (orientation: landscape){
  .title {
    font-size: 1.5rem;
    font-weight: 500;
    width: 100%;
    /*text-shadow: 1px 1px black;*/
  }
  .info {
    font-size: 1rem;
    width: 100%;
    /*text-shadow: 1px 1px black;*/
  }
  .applying-btn{
    font-size: 0.80rem;
  }
  #additionalInfoList {
    font-size: 0.9rem;
  }
  #list-content {
    padding-top: 0.5rem;
    margin-top:0;
    /*text-shadow: 1px 1px black;*/
  }
}
</style>
